import { array, fallback, literal, nullish, object, pipe, transform, union } from "valibot"
import { baseCatalogueSchema } from "./catalogue"
import { documentSchema } from "./document"
import { productSchema } from "./product"

const childSchema = union([
  productSchema,
  documentSchema,
])

/**
 * Schema for Crystallize folders.
 *
 * @see https://crystallize.com/learn/concepts/pim/folder
 */
export const folderSchema = object({
  ...baseCatalogueSchema.entries,
  type: literal("folder"),
  // TODO: If we at some point have nested folders, this must me made recursive.
  children: fallback(
    pipe(
      array(fallback(nullish(childSchema), null)),
      transform(items => items.filter((child): child is NonNullable<typeof child> => child !== null)),
    ),
    [],
  ),
})
